import { l } from '@manychat/manyui'

import { billing } from 'common/billing/billingService/billingService'
import { getBillingAPI } from 'common/billing/entities/billingVersions/selectors'
import {
  PreviewInvoice,
  PreviewInvoiceForLiveChatSeatsRequest,
} from 'common/billing/entities/previewInvoice/interfaces'
import { UpgradeSource } from 'common/billing/interfaces'
import { alert } from 'common/core'
import { Ability } from 'common/core/constants/Ability'
import { UsersApi } from 'shared/api/requests/users'
import { createAsyncAction } from 'shared/lib/redux'

export const previewInvoiceForLiveChatSeats = createAsyncAction<
  PreviewInvoice,
  PreviewInvoiceForLiveChatSeatsRequest
>(
  `billingFlex/previewInvoiceForLiveChatSeats`,
  async (payload, { getState }) => {
    const billingAPI = getBillingAPI(getState())
    const response = await billingAPI.previewInvoiceForLiveChatSeats({
      body: { seats_count: payload.seats_count },
    })

    return response.data
  },
  {
    errorMarkupOptions: {
      scope: 'settings',
      section: 'team_members',
    },
    onBusinessError: (error) => {
      error.handle()

      if (billing.isProError(error)) {
        billing.handleProError(error, {
          showPaywall: error.error_data.go_pro,
          source: UpgradeSource.SETTINGS_TEAM,
          message: l.translate('Upgrade your plan to manage Inbox seats.'),
          abilities: [Ability.AUTO_ASSIGN, Ability.LIVECHAT_SEATS],
        })
        return
      }

      if (UsersApi.setInboxUser.isBillingAccessError(error)) {
        alert(error.message, 'danger')
      }
    },
  },
)
